import type { PollRecipient } from "../context/moment-polls-context";

// Produces a human-readable "contact" for a poll recipient. The raw `destination`
// is often an opaque channel id (e.g. a Slack/Teams id), so we prefer the email
// address, then the nice display name, only falling back to the raw destination.
export const pollContact = (
  person: Pick<PollRecipient, "email" | "display" | "destination">,
): string | null => person.email || person.display || person.destination || null;
